"use client";
import { Canvas } from "../components/Canvas";
import { CanvasBackground } from "../components/CanvasBackground";

export function TemplatePage() {
  return (
    <Canvas>
      <CanvasBackground />
    </Canvas>
  );
}
